import React, { useState, useRef, useEffect } from "react";
import Button from "../Buttons/Button";
import FormFieldSet from "../FormFields/FormFieldSet";

const ExpandableWrapper = ({
  title = "",
  children,
  dateValue = { from: "", to: "" },
  expandedContent = null,
  expandedMaxWidth = "max-w-3xl",
  onExpand = () => {},
  onCollapse = () => {},
  expandIcon = true,
  datepicker = false,
  toggleChart = true,
  onDateChange,
  className = "",
  expandedChartHeight = "h-full",
  expandedChartWidth = "w-full",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [originalPosition, setOriginalPosition] = useState(null);
  const [dates, setDates] = useState(dateValue);
  const wrapperRef = useRef(null);

  const handleExpand = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft =
        window.pageXOffset || document.documentElement.scrollLeft;

      setOriginalPosition({
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft,
        width: rect.width,
        height: rect.height,
        scrollPosition: { x: scrollLeft, y: scrollTop },
      });
    }
    setIsExpanded(true);
    onExpand();
  };

  const handleDateChange = (value) => {
    setDates(value);
    onDateChange(value);
  };
  console.log(dates);

  const handleCollapse = () => {
    setIsExpanded(false);
    onCollapse();

    setTimeout(() => {
      if (originalPosition) {
        window.scrollTo(
          originalPosition.scrollPosition.x,
          originalPosition.scrollPosition.y
        );
      }
    }, 300);
  };
  console.log(expandedContent);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isExpanded) {
        handleCollapse();
      }
    };

    if (isExpanded) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "auto";
    };
  }, [isExpanded]);

  if (isExpanded) {
    return (
      <div className="fixed inset-0 z-55 bg-white flex flex-col overflow-auto animate-fadeIn">
        <div className={`w-full ${expandedMaxWidth} py-4`}>
          <Button
            variant="text"
            color="black"
            icon={"arrow_left_alt"}
            title={"Back"}
            onClick={handleCollapse}
          />
        </div>
        <div
          className={`flex justify-center px-4 ${expandedChartHeight} w-full`}
        >
          <div className={` ${expandedChartHeight} ${expandedChartWidth}`}>
            {children}
          </div>
        </div>
        {expandedContent && (
          <div className="w-full pt-8">{expandedContent}</div>
        )}
      </div>
    );
  }

  return (
    <div
      ref={wrapperRef}
      className={`h-full rounded-lg  w-full ${className} flex flex-col`}
    >
      <div className="flex justify-between items-center mb-2">
        <h6 className="text-lg font-medium">{title}</h6>
        {/* <button
          className="p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-200"
          title="Expand"
        >
          Expand
        </button> */}
        <div className="flex gap-2 items-center">
          {datepicker && (
            <FormFieldSet
              type="datepickerRange"
              placeholder="Select date range"
              size="sm"
              noTitle
              value={dates}
              onChange={handleDateChange}
            />
          )}
          {toggleChart && (
            <Button
              type="icon"
              variant="text"
              icon={"bar_chart"}
              // onClick={handleExpand}
              color="black"
            />
          )}
          {expandIcon && (
            <Button
              type="icon"
              variant="text"
              icon={"arrows_output"}
              onClick={handleExpand}
              color="black"
            />
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default ExpandableWrapper;
